// client/guest/components/NoEventBlock.tsx
// client/guest/components/NoEventBlock.tsx
import React from "react";

export default function NoEventBlock() {
  return (
    <div className="grid place-items-center text-center flex-1 min-h-0">
      <div className="max-w-sm">
        <div className="mx-auto w-12 h-12 rounded-2xl bg-white/10 grid place-items-center text-lg text-white/85">
          🕓
        </div>
        <div className="mt-3 text-[15px] font-semibold text-white">
          Сейчас нет активного мероприятия
        </div>
        <div className="mt-1 text-[13px] text-white/70">
          Попробуйте зайти позже. Как только появится новое событие — здесь
          появятся шаги регистрации и оплаты.
        </div>
      </div>
    </div>
  );
}